module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 2\n  </title>\n  <path d=\"M16.111 1H1.89A.889.889 0 0 0 1 1.89V16.11c0 .491.399.89.89.89h7.657v-6.188H7.47V8.391h2.077V6.613c0-2.066 1.263-3.193 3.112-3.193.622-.002 1.244.03 1.862.095v2.152h-1.276c-1.002 0-1.198.477-1.198 1.178v1.542h2.398l-.31 2.422h-2.088V17h4.065c.49 0 .889-.398.889-.889V1.89A.889.889 0 0 0 16.11 1\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-18-facebook.svg
// module id = 3697
// module chunks = 168707334958949